<template>
  <div
    v-if="$store.getters.marchand && $store.getters.marchand._env === 'live'"
    class="row"
    style="padding: 5px"
  >
    <div class="col-12 mb-4">
      <div class="pb-4">
        <v-btn
          @click="$router.go(-1)"
          outlined
          style="border: none; background: #fff"
          title="Retourner"
        >
          <v-icon>mdi mdi-arrow-left-thin</v-icon> retour
        </v-btn>
      </div>
      <h5>Années académiques de {{ school?._name }}</h5>
      <v-row>
        <v-col
          v-for="(item, index) in classes"
          :key="index"
          cols="12"
          sm="6"
          md="3"
        >
          <v-card
            style="background-color: white !important; cursor: pointer"
            class="p-2"
          >
            <!-- Top row with image, name, and menu -->
            <v-row align="center" no-gutters>
              <v-col class="px-4 pt-3">
                <h3 class="text-lg">
                  {{ item._name ? item._name : "N/A" }}
                </h3>
              </v-col>
              <v-spacer></v-spacer>
              <v-col cols="auto" class="pr-4">
                <!--  <v-btn
                  x-small
                  dark
                  color="orange"
                  fab
                  outlined
                  class="mx-2"
                  @click="editItemAction(item, 0)"
                >
                  <v-icon small>mdi-pencil-outline</v-icon>
                </v-btn> -->
                <v-btn
                  x-small
                  dark
                  outlined
                  color="pink"
                  fab
                  @click="editItemAction(item, 2)"
                >
                  <v-icon small>mdi-trash-can-outline</v-icon>
                </v-btn>
              </v-col>
            </v-row>
            <v-card-text class="py-0">
              <v-col class="text-left px-0">
                <h6>
                  <v-icon small>mdi-calendar</v-icon> Du :
                  <span style="color: black">
                    {{ getformatDate(item._startDate) }}
                  </span>
                  Au :
                  <span style="color: black">
                    {{ getformatDate(item._endDate) }}
                  </span>
                </h6>
              </v-col>
              <div class="text-right">
                <v-btn
                  small
                  outlined
                  color="#29B3A6"
                  @click="editItemAction(item, 0)"
                >
                  Classes <v-icon small>mdi-arrow-right-thin</v-icon>
                </v-btn>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" sm="6" md="3">
          <div @click="dialogCustomer = true" class="add_btn">
            <div class="text-center" style="font-size: 15pt">
              Ajouter une nouvelle année
            </div>
          </div>
        </v-col>
      </v-row>

      <v-dialog v-model="dialogCustomer" max-width="400px">
        <v-card>
          <v-card-text>
            <v-form ref="clientForm" v-model="clientFormIsValid">
              <v-container>
                <h3 class="pb-5 pt-5">Ajouter une année académique</h3>
                <v-row>
                  <v-col cols="12" sm="4">
                    <v-text-field
                      v-model="academicYearToSave._name"
                      :rules="requiredRules"
                      label="Nom"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="4">
                    <v-menu
                      v-model="pickdateprogram"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="academicYearToSave._startDate"
                          label="Date de début"
                          prepend-icon="mdi-calendar"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="academicYearToSave._startDate"
                        @input="pickdateprogram = false"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col cols="12" sm="4">
                    <v-menu
                      v-model="pickdateprogramEnd"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="academicYearToSave._endDate"
                          label="Date de fin"
                          prepend-icon="mdi-calendar"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="academicYearToSave._endDate"
                        @input="pickdateprogramEnd = false"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>
                </v-row>
              </v-container>
            </v-form>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="dark"
              @click="(dialogCustomer = false), (editingCustomer = false)"
            >
              Annuler
            </v-btn>
            <v-btn
              v-if="!editingCustomer"
              :loading="loadings.fee_saving"
              color="primary"
              :disabled="!academicYearToSave._name"
              @click="saveAcademicYear()"
            >
              Enregistrer
            </v-btn>
            <v-btn
              v-if="editingCustomer"
              :loading="loadings.fee_saving"
              :disabled="!academicYearToSave._name"
              color="primary"
              @click="updateFee()"
            >
              Mettre à jour
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </div>
  <div v-else>
    <go-to-params></go-to-params>
  </div>
</template>

<script>
import { mapState } from "vuex";
import GoToParams from "../administrators/globalComponents/GoToParams";
import { client } from "../../store/services/client";
import Swal from "sweetalert2";

export default {
  components: {
    GoToParams,
  },
  data() {
    return {
      // Only keep necessary data properties
      loadings: {
        classes: false,
        fee_saving: false,
      },
      pickdateprogram: false,
      pickdateprogramEnd: false,
      search: "",
      dialogCustomer: false,
      academicYearToSave: {
        _name: "",
        _startDate: "",
        _endDate: "",
      },
      headers: [
        { text: "Nom", value: "_name" },
        { text: "Date de début", value: "_startDate" },
        { text: "Date de fin", value: "_endDate" },
        { text: "", value: "actions" },
      ],
      editingCustomer: false,
      classes: [],
      school: undefined,
      actions_items: [
        { title: "Voir les classes", avatar: "mdi-eye" },
        { title: "Transactions", avatar: "mdi-cash-multiple" },
        { title: "Supprimer", avatar: "mdi-delete" },
      ],
      requiredRules: [(v) => !!v || "Ce champ est requis"],
    };
  },
  computed: {
    ...mapState("countries/", ["countries"]),
  },
  mounted() {
    this.initialize();
  },
  created() {
    this.checkisDashboard();
  },
  methods: {
    getformatDate(value) {
      if (value) {
        return Intl.DateTimeFormat("fr-FR", {
          year: "numeric",
          month: "short",
          day: "2-digit",
        }).format(new Date(value));
      }
    },
    editItemAction(item, index) {
      switch (index) {
        case 0:
          this.$router.push({
            name: "intramScholar.classes",
            params: { school_id: this.$route.params.school_id },
            query: { academic_year: item._id },
          });
          break;
        case 1:
          this.$router.push({
            name: "intramScholar.transactions",
            params: { school_id: this.$route.params.school_id },
            query: { academic_year: item._id },
          });
          break;
        case 2:
          this.toggleDeleteAcademicYear(item);
          break;
      }
    },
    async initialize() {
      if (this.$store.getters.marchand) {
        this.getAllAcademicYears();
        this.getSchool();
      }
    },
    checkisDashboard() {
      this.$emit("checkisDashboard", true);
    },
    async getSchool() {
      const response = await client({
        method: "get",
        url: `/school-payments/schools/${this.$route.params.school_id}`,
      })
        .then((resp) => resp.data)
        .catch(() => ({ error: "true" }));

      if (!response.error) {
        this.school = response;
      }
    },
    async getAllAcademicYears() {
      this.loadings.classes = true;
      const response = await client({
        method: "get",
        url: `/school-payments/school-settings/school/${this.$route.params.school_id}/academic-year`,
      })
        .then((resp) => resp.data)
        .catch(() => ({ error: "true" }));

      this.loadings.classes = false;
      if (!response.error) {
        this.classes = response;
      }
    },
    async saveAcademicYear() {
      if (this.$refs.clientForm.validate()) {
        this.loadings.fee_saving = true;
        const response = await client({
          method: "post",
          url: `/school-payments/school-settings/school/${this.$route.params.school_id}/academic-year`,
          data: this.academicYearToSave,
        })
          .then((resp) => resp.data)
          .catch(() => ({ error: "true" }));

        this.loadings.fee_saving = false;
        this.dialogCustomer = false;
        this.getAllAcademicYears();
        this.toast(response.type, response.message);
      }
    },
    async updateFee() {
      if (this.$refs.clientForm.validate()) {
        this.loadings.fee_saving = true;
        const response = await client({
          method: "PUT",
          url: `/school-payments/fees/${this.id}`,
          data: this.academicYearToSave,
        })
          .then((resp) => resp.data)
          .catch(() => ({ error: "true" }));

        this.loadings.fee_saving = false;
        this.editingCustomer = false;
        this.dialogCustomer = false;
        this.getAllAcademicYears();
        this.toast(response.type, response.message);
      }
    },
    toggleDeleteAcademicYear(item) {
      Swal.fire({
        icon: "warning",
        text: this.$t("delete_warning"),
        confirmButtonText: "Supprimer",
        cancelButtonText: "Annuler",
        showCancelButton: true,
        cancelButtonColor: "#CCC",
        confirmButtonColor: "#29B3A6",
        preConfirm: async () => {
          Swal.showLoading();
          try {
            const response = await client({
              method: "delete",
              url: `/school-payments/school-settings/academic-year/${item._id}`,
            });
            Swal.hideLoading();
            Swal.fire({
              icon: "success",
              text: "Suppression réussie",
              confirmButtonText: "Ok",
              confirmButtonColor: "#29B3A6",
            });
            await this.getAllAcademicYears();
            return response.data;
          } catch (error) {
            Swal.hideLoading();
            Swal.fire({
              icon: "error",
              text: "Erreur lors de la suppression",
              confirmButtonText: "Ok",
              confirmButtonColor: "#29B3A6",
            });
            return { error: "true" };
          }
        },
        allowOutsideClick: () => !Swal.isLoading(),
      });
    },
  },
};
</script>
